<!-- Navigation -->
<nav class="navbar navbar-default fixed-top  w-100" style="background-color: #2b2b2b !important;">
  <my-navigation></my-navigation>
</nav>
<div class="contact-cta" *ngIf="globals.hostnameStr==='oakvillesluxuryrealestate.com'">
  <div class="inner-wrapper">
    <h3>Contact</h3>
    <p>Donna Gray: <a href="tel:4162760632">416.276.0632</a></p>
  </div>
</div>
<div class="contact-cta" *ngIf="globals.hostnameStr==='mineolaluxuryrealestate.com'">
  <div class="inner-wrapper">
    <h3>Contact</h3>
    <p>Natalie Costello: <a href="tel:6479661326">647.966.1326</a></p>
  </div>
</div>
<!-- form Section -->
<section id="form" class="forms search-results-page-filters clearfix">
  <my-muskoka-listing-search (filterListings)="filterListings($event)"></my-muskoka-listing-search>
  <div class="search-results-totals">
      <span *ngIf="listings">
         <h3>Showing {{ listings.length }} of {{ globals.countNum }} properties</h3>
      </span>
  </div>
  <main id="searchResults" class="clearfix"
        infiniteScroll
        [infiniteScrollDistance]="50"
        [infiniteScrollUpDistance]="1"
        [infiniteScrollThrottle]="0"
        (scrolled)="onScrollDownGlobal()"
        (scrolledUp)="onScrollUpGlobal()"
        [scrollWindow]="true"
        [alwaysCallback]="true"
  >
    <div id="resultsList"
         infiniteScroll
         [infiniteScrollDistance]="7"
         [infiniteScrollUpDistance]="1"
         [infiniteScrollThrottle]="50"
         (scrolled)="onScrollDown()"
         (scrolledUp)="onScrollUp()"
         [scrollWindow]="false">

      <!-- SSR fallback: when currentScreenSize is not yet determined on the server, render a default list -->
      <ng-container *ngIf="!currentScreenSize">
        <app-property-card *ngFor="let listing of listings"
                           [listing]="listing"
                           (cardClick)="gotoDetailDirect(listing)">
        </app-property-card>
      </ng-container>

      <ng-container *ngIf="currentScreenSize==='XSmall'">
        <app-property-card *ngFor="let listing of listings"
                           [listing]="listing"
                           (cardClick)="gotoDetailDirect(listing)">
        </app-property-card>
      </ng-container>

      <ng-container *ngIf="currentScreenSize==='Small' || currentScreenSize==='Medium'">
        <app-property-card *ngFor="let listing of listings"
                           [listing]="listing"
                           (cardClick)="gotoDetailDirect(listing)">
        </app-property-card>
      </ng-container>

      <ng-container *ngIf="currentScreenSize==='Large' || currentScreenSize==='XLarge'">
        <app-property-card *ngFor="let listing of listings"
                           [listing]="listing"
                           (cardClick)="gotoDetail(listing)">
        </app-property-card>
      </ng-container>


      <div class="end-of-list" *ngIf="listings.length < this.globals.countNum">
        <p>Your results are loading.</p>
      </div>
    </div>
    <div class="active-property" *ngIf="shouldShowProperty(); else (shouldShowLoadingTemplate() ? loadingTemplate : null)">
      <div class="gallery">
        <ng-container *ngIf="selectedListing">
          <app-ngbd-carousel-config
            [imageArr]="selectedListing.listingMedia.data"
            [addressHyphenStr]="selectedListing.listingDetail?.address.replaceAll(' ', '-')"
            [cityHyphenStr]="selectedListing.municipality.replaceAll(' ', '-')"
            [MLSNum]="selectedListing.MLSNUM">
          </app-ngbd-carousel-config>
        </ng-container>
      </div>

      <ng-container *ngIf="selectedListing">
        <div class="content">
          <div id="propertyPrice" class="price">{{ selectedListing.listingPrice | currency : '' : 'symbol' : '1.0-0' }} <span
            *ngIf="(selectedListing.listingStatus | lowercase)==='rental'">/ Week</span>
          </div>
          <div class="row">
            <p id="propertyLocation" class="location" style="padding-left: 0 !important">{{ selectedListing.listingDetail?.address }}</p>
          </div>
          <div class="row">
            <p id="propertyDescription" class="description"><span *ngIf="selectedListing.sourceStr==='TREB'">{{ selectedListing.fullAddress }}</span><span
              *ngIf="selectedListing.sourceStr==='TREB'">{{ selectedListing.community }}</span></p>
          </div>
          <div *ngIf="(selectedListing.listingStatus | lowercase)!=='rental' && selectedListing.squareFootage && selectedListing.squareFootage!=='0'" class="row">
            <p id="propertyFeet" class="feet" style="padding-left: 0 !important">{{ selectedListing.squareFootage }} sq. FT.</p>
          </div>
          <div *ngIf="(selectedListing.listingStatus | lowercase)==='rental' && selectedListing.listingDetail?.numBeds" class="row">
            <p id="propertyFeet" class="feet" style="padding-left: 0 !important">{{ selectedListing.listingDetail?.numBeds }} Bedrooms</p>
          </div>
          <div *ngIf="(selectedListing.listingStatus | lowercase)==='rental' && (selectedListing.listingDetail?.numBathsFull || selectedListing.bathroomsTotal)" class="row">
            <p id="propertyFeet" class="feet" style="padding-left: 0 !important">{{ selectedListing.listingDetail?.numBathsFull }} Bathrooms</p>
          </div>
          <div class="row">
            <ul class="links">
              <li *ngIf="selectedListing.listingDetail?.virtualTour"><a id="virtualTour" href="{{selectedListing.listingDetail?.virtualTour}}" target="_blank">Virtual Tour</a></li>
              <li *ngIf="selectedListing.listingDetail?.brochureLink"><a id="brochure" href="{{selectedListing.listingDetail?.brochureLink}}" target="_blank">Brochure</a></li>
            </ul>
          </div>
          <div class="row">
            <!--<a id="viewFullDetails" class="full-details-link" href="http://m2.caymanmarshall.com/fulldetails/{{selectedListing.MLSNUM}}" target="_blank">View full details</a>-->
            <a id="viewFullDetails" class="full-details-link"
               [routerLink]="'fulldetails/' + selectedListing.listingDetail?.address.replaceAll(' ', '-') + '/' + selectedListing.municipality.replaceAll(' ', '-') + '/' + selectedListing.MLSNUM">View
              Full
              Details</a>
          </div>
          <div class="row">
            <h3 class="description-heading">Description</h3>
          </div>
          <div class="row">
            <p class="description" [innerHTML]="sanitizedDescription(selectedListing.description)"
            ></p>
          </div>
          <br>
          <br>
          <div class="row">
            <ul class="features">
              <li *ngIf="selectedListing.squareFootage && selectedListing.squareFootage!=='0'" id="feet">{{ selectedListing.squareFootage }} Sq. Ft.</li>
              <li *ngIf="selectedListing.lotSize" id="acres">{{ selectedListing.lotSize }}</li>
              <li *ngIf="selectedListing.listingDetail?.numBeds" id="bedrooms">{{ selectedListing.listingDetail?.numBeds }} Bedrooms</li>
              <li *ngIf="selectedListing.listingDetail?.numBathsFull || selectedListing.bathroomsTotal" id="bathrooms">
                {{ selectedListing.listingDetail?.numBathsFull ?? selectedListing.bathroomsTotal }}
                Bathrooms
              </li>

            </ul>
          </div>
        </div>
      </ng-container>
    </div>
  </main>
</section>
<ng-template #loadingTemplate>
  <div class="loading-placeholder loading-placeholder--initial">
    <div class="spinner-border" style="color: #CA6924;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p style="color: #2b2b2b;">Loading property details...</p>
  </div>
</ng-template>



